import React, { useRef, useState, useEffect } from "react";
import Container from "react-bootstrap/Container";
import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import VideoJS from "./videoJS";
import Definitions from "../definitions";
import ShareModal from "../share/ShareModal";
const VideoScreen = ({
  video,
  currentItem,
  items,
  backClick,
  users,
  setUsers,
  updateItems,
}) => {
  const [workshopPartIndex, setWorkshopPartIndex] = useState(0);
  const [current, setCurrent] = useState(0); // Video parts for workshops

  const [libraryResources, setLibraryResources] = useState((video.library_resources)?video.library_resources: []);

  const playerRef = React.useRef(null);
  const [videoContent, setVideoContent] = useState(video);
  const loadedRef = React.useRef(false);
  const progressRef = React.useRef(0);

  const [videoTitle, setVideoTitle] = useState(""); // Used for video part swapping.

  const [showShare, setShowShare] = useState(false);
  const [isQuizDisabled, setIsQuizDisabled] = useState(true);
  const buttonArrow = <div class="btn-arrow"></div>;

  const [vjsOptions, setVjsOptions] = useState({
    preload: "auto",
    controls: true,
    fluid: true,
    responsive: true,
    partIndex: 0,
    sources: [
      {
        src: video?.url,
        poster: video?.thumb?.[0],
        type: "application/x-mpegURL",
      },
    ],
  });

  useEffect(() => {
    setVideoTitle(currentItem?.title);
    setVjsOptions((prev) => ({
      ...prev,
      sources: [
        {
          src: video?.url,
          poster: video?.thumb?.[0],
          type: "application/x-mpegURL",
        },
      ],
    }));
  }, [video]);

  const loadVideoPart = (url, thumb, title, index) => {
    // setVideoThumb(thumb);
    setVideoTitle(title);
    setVjsOptions((prev) => ({
      ...prev,
      partIndex: index,
      sources: [{ src: url, poster: thumb, type: "application/x-mpegURL" }],
    }));
  };

  const shareClick = (item) => {
    setShowShare(true);
  };

  const closeShare = () => setShowShare(false);

  /**
   * Update video progress on user every 10%
   * @param {} player
   * @param {*} e
   */
  const onVideoUpdate = (player, e, wsPartIndex) => {
    // Update time on video bar
    let d = player.remainingTime().toFixed(0);
    var h = Math.floor(d / 3600);
    var m = Math.floor((d % 3600) / 60);
    var s = Math.floor((d % 3600) % 60);

    // Add leading 0 to minutes
    if (m < 10) {
      m = "0" + m;
    }
    // Add leading 0 to seconds
    if (s < 10) {
      s = "0" + s;
    }
    document.querySelector(
      ".vjs-remaining-time-display"
    ).innerHTML = `${h}:${m}:${s}`;
    // Set currentTime to stored video progress
    if (
      loadedRef.current === false &&
      video.progress > 0 &&
      video.progress != 100
    ) {
      player.currentTime(player.duration() * (video.progress / 100));
      loadedRef.current = true;
    }

    let percentWatched = Math.floor(
      (player.currentTime() / player.duration()) * 100
    );

    // Activate quiz button when there is less than a minute left
    if (s <= 60 && h == 0 && m == 0 && d != 0) {
      if (videoContent?.parts) {
        if (wsPartIndex == videoContent.parts.length - 1) {
          setIsQuizDisabled(false);
        }
      } else {
        setIsQuizDisabled(false);
      }
    }

    // We want to customize the progress for workshops a bit, every time they finish a video we want to increment it another 25%
    if (videoContent?.parts) {
      // Lets set this video to 100% watched if its at least 80% watched
      if (percentWatched >= 80) {
        // Get the current video part
        // This is 25, 50, 75, 100 for 4 part videos
        let watchedPercent =
          (100 / videoContent.parts.length) * (wsPartIndex + 1);

        // Only run if progressRef is LT watchedPercent
        if (watchedPercent > progressRef.current) {
          let nonce = document.getElementById("_wpnonce").value;
          progressRef.current = watchedPercent;

          fetch(
            "/wp-json/library/v1/video/" +
              currentItem.id +
              "/progress/" +
              watchedPercent,
            {
              method: "post",
              mode: "cors",
              headers: {
                "Access-Control-Allow-Origin": "*",
                "X-WP-Nonce": nonce, // here you used the wrong name
              },
            }
          )
            .then((response) => response.json())
            .then((data) => {});
        }

        //
      }
    } else if (
      percentWatched > progressRef.current &&
      percentWatched !== 0 &&
      percentWatched % 10 === 0 // Update every 10%
    ) {
      progressRef.current = percentWatched;
      // Update item progress
      let nonce = document.getElementById("_wpnonce").value;

      fetch(
        "/wp-json/library/v1/video/" +
          currentItem.id +
          "/progress/" +
          percentWatched,
        {
          method: "post",
          mode: "cors",
          headers: {
            "Access-Control-Allow-Origin": "*",
            "X-WP-Nonce": nonce, // here you used the wrong name
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {});
    }
  };

  /**
   * When the video starts, update user account
   */
  const onVideoStart = (player, e) => {
    // if (playerRef.current !== player) return;
  };

  /**
   * When video ends, update user account
   */
  const onVideoEnd = (player, e, wsPartIndex) => {
    // if (playerRef.current !== player) return;
    if (videoContent?.parts) {
      if (wsPartIndex == videoContent.parts.length - 1) {
        setIsQuizDisabled(false);
      }
    } else {
      setIsQuizDisabled(false);
    }
  };

  const title = currentItem.title ? (
    <Row
      className="video__title"
      dangerouslySetInnerHTML={{ __html: videoTitle ?? currentItem.title }}
    ></Row>
  ) : (
    ""
  );

  const subtitle = currentItem.subtitle ? (
    <Row
      className="video__subtitle"
      dangerouslySetInnerHTML={{ __html: currentItem.subtitle }}
    ></Row>
  ) : (
    ""
  );
  const content_type = Definitions[currentItem.content_type].title ? (
    <Row className="video__contenttype">
      {Definitions[currentItem.content_type].title}
    </Row>
  ) : (
    ""
  );

  const workshopParts = videoContent?.parts
    ? videoContent?.parts.map((el, videoIndex) => (
        <Button
          onClick={() => {
            setWorkshopPartIndex(videoIndex);
            setCurrent(el);
            setLibraryResources(el.library_resources);
            loadVideoPart(el.url, el.thumb, el.title, videoIndex);
          }}
          className={el === current ? "part__btn--active" : "part__btn"}
          dangerouslySetInnerHTML={{
            __html: el.title + '<div class="btn-arrow"></div>',
          }}
        ></Button>
      ))
    : "";

  const convertDate = () => {
    const date = new Date(parseInt(currentItem.latest_expiration_date + "000"));
    var options = { year: "numeric", month: "long", day: "numeric" };
    return date.toLocaleDateString("en-US", options);
    // M d, y
  };

  const dateDisplay =
    currentItem?.latest_expiration_date &&
    currentItem?.latest_expiration_date != 0 ? (
      <Container className="expires">
        <span>Expires:</span> <span>{convertDate()}</span>
      </Container>
    ) : (
      ""
    );

  const attachment_title =
    currentItem?.content_type == "on-demand-webinar" ||
    currentItem?.content_type == "on-demand-webinar-2"
      ? "Powerpoint"
      : "Manual";

  const attachmentButton = videoContent?.attachment ? (
    <Button
      className="attachment"
      href={videoContent?.attachment}
      target="_blank"
    >
      Download: {attachment_title}
      {buttonArrow}
    </Button>
  ) : (
    ""
  );

  const certificateButton = video?.quiz ? (
    <Button
      disabled={isQuizDisabled}
      className="quiz"
      href={"/quiz/" + currentItem?.id}
      target="_blank"
    >
      Take the Test
      {buttonArrow}
    </Button>
  ) : (
    ""
  );

  const shareButton = () => {
    if (
      currentItem?.license_count > 0 &&
      currentItem?.tag !== "contract" &&
      currentItem?.tag !== "free" &&
      currentItem?.tag !== "shared" &&
      currentItem?.tag !== "member"
    ) {
      return (
        <Container className="share">
          <Col>
            <Button
              className="sharebtn"
              onClick={() =>
                currentItem?.license_count > 1
                  ? shareClick(currentItem)
                  : alert("Error. Can't share a video in progress!")
              }
            >
              Share
            </Button>
          </Col>

          <Col>
            Shares: {currentItem?.license_used}/{currentItem?.license_count}
          </Col>
        </Container>
      );
    }
  };

  const ViewLibraryBtn =
    (currentItem?.tag === "contract" || currentItem?.tag === "free") &&
    items.length === 1 ? (
      ""
    ) : (
      <Row className="video__back">
        <Button onClick={backClick}>
          View Library
          {buttonArrow}
        </Button>
      </Row>
    );

  const TrainerDetails = currentItem?.trainername ? (
    <Container className="trainer">
      <strong className="trainer--label">Trainer</strong>
      <img className="trainer--image" src={currentItem.trainerimg} />
      <span className="trainer--name">
        {currentItem.trainername} {currentItem.trainertitle}
      </span>
    </Container>
  ) : (
    ""
  );

  function displayShareModal() {
    if (currentItem.tag !== "member" && currentItem.tag !== "shared") {
      <ShareModal
        show={showShare}
        setUsers={setUsers}
        users={users}
        close={closeShare}
        item={currentItem}
        items={items}
        updateItems={updateItems}
      />;
    }
  }

  const LibraryResources = () => {
    if (libraryResources) {
      
      return (
        <Container className="buttons">
          {libraryResources.map((el) => (
            <Button className="attachment" href={el.url} target="_blank">
              {el.title}
              {buttonArrow}
            </Button>
          ))}
        </Container>
      );
    }
  };

  const webinarDescription = {
    textAlign: 'center',
    paddingTop: '15px',

  };

  return (
    <Container className="video">
      <Container className="video__top">
        {content_type}
        {title}
        {subtitle}
        {ViewLibraryBtn}
        <Container style={webinarDescription}>Once you have completed the training, you must take the test to receive your certificate of completion. Tests take around 10 minutes to complete for a webinar, and 30-60 minutes for a workshop and must be completed in one sitting.</Container>
      </Container>
      <Container className="video__content">
        <Col className="video__player">
          <div data-vjs-player>
            <VideoJS
              currentWorkshopIndex={workshopPartIndex}
              video={video}
              vjsOptions={vjsOptions}
              currentItem={currentItem}
              onVideoStart={onVideoStart}
              onVideoUpdate={onVideoUpdate}
              onVideoEnd={onVideoEnd}
            />
          </div>
          {LibraryResources()}
        </Col>
        <Col className="video__info">
          {workshopParts}
          {dateDisplay}
          {shareButton()}
          <Container className="buttons">
            {attachmentButton}
            {certificateButton}
          </Container>
          <Container className="description">
            <div
              dangerouslySetInnerHTML={{ __html: currentItem.description }}
            ></div>
          </Container>
          {TrainerDetails}
        </Col>
      </Container>
      {displayShareModal()}
    </Container>
  );
};

export default VideoScreen;
